import { checkIcon } from "assets/images";

const CheckedBoxIcon = () => {
  return <img src={checkIcon} alt="checkbox" />;
};

export default CheckedBoxIcon;
